export default __webpack_public_path__ + "static/media/twitter-icon.55b24108.svg";